module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"display_insect_graphs":"捕虫グラフ表示","close":"閉じる"},"en":{"display_insect_graphs":"Display Insect Graphs","close":"Close"}}')
  delete Component.options._Ctor
}
